module.exports = __webpack_public_path__ + "0372cf53132a0c3b5d7892df209a5acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/cta/icon_cars-comparison_light.png
// module id = 732
// module chunks = 0 1